import { useCallback } from 'react';
import { useGetTeamsQuery, useGetUsersForSelectQuery } from '../../../services';
import { ProspectAllowedCaller, RoleFilterType, Roles, Team } from '../../../types';
import { MultiSelect } from '../Select';

interface ShareWithFieldProps {
  selectedCallers: ProspectAllowedCaller[];
  selectedTeams: Team[];
  setSelectedCallers: (callers: ProspectAllowedCaller[]) => void;
  setSelectedTeams: (teams: Team[]) => void;
}

const ShareWithField = ({
  selectedCallers,
  selectedTeams,
  setSelectedCallers,
  setSelectedTeams,
}: ShareWithFieldProps) => {
  const { data: orgUsers = { users: [] } } = useGetUsersForSelectQuery({
    roleFilterType: RoleFilterType.SPECIFY_ROLES,
    roles: [Roles.SALES_REP],
  });

  const { data: orgTeams = [] } = useGetTeamsQuery();

  const callerOptions = orgUsers.users.map((user) => ({
    label: user.name ?? user.email ?? '',
    value: user.id,
  }));

  const teamOptions = orgTeams.map((team) => ({
    label: team.name,
    value: team.id,
    color: team.color,
  }));

  const shareWithOptions = [...callerOptions, ...teamOptions];
  const shareWithIds = [...selectedCallers.map((c) => c.id), ...selectedTeams.map((t) => t.id)];

  const onShareWithChange = useCallback(
    (selected?: string[]) => {
      const selectedCallers = orgUsers.users.filter((user) => selected?.includes(user.id));
      setSelectedCallers(
        selectedCallers.map((user) => ({
          id: user.id,
          email: user.email ?? '',
          name: user.name ?? '',
        }))
      );

      const selectedTeams = orgTeams.filter((team) => selected?.includes(team.id));
      setSelectedTeams(selectedTeams);
    },
    [orgUsers, orgTeams]
  );

  return (
    <MultiSelect
      placeholder="Select representatives or teams"
      options={shareWithOptions}
      selected={shareWithIds}
      onChange={onShareWithChange}
    />
  );
};

export default ShareWithField;
